import { Route } from 'react-router-dom';

import AdminLayout from '../../layouts/Admin.layout';
import { BASE_ADMIN_V2_PATH } from '../../shared/admin/constants/path.constants';
import { ADMIN_STATISTICS_V2_APP_PATHS } from '../../shared/statistics/constants/path.constants';
import AdminStatisticsRoutes from '../../statistics/routes/admin-statistics.routes';
import AdminStatisticsCommissionPage from '../../views/admin/statistics/commission/Page';
import AdminStatisticsSalesPage from '../../views/admin/statistics/sales/Page';
import AdminOrganizationsRoutes from '../../organizations/routes/admin-organizations.routes';
import AdminUsersRoutes from '../../users/routes/admin-users.routes';
import AdminOrdersRoutes from '../../orders/routes/admin-orders.routes';
import AdminInvitationsRoutes from '../../invitations/routes/admin-invitations.route';
import AuthenticatedAdminGuard from '../../shared/routes/authenticated-admin-guard.route';
import AdminDeliveryPointsRoutes from '../../delivery-points/routes/admin-delivery-points.route';
import AdminDeliveryCitiesRoutes from '../../delivery-cities/routes/admin-delivery-cities.route';
import AdminDeliveryZonesRoutes from '../../delivery-zones/routes/admin-delivery-zones.route';
import AdminSegmentsRoutes from '../../segments/routes/admin-segments.route';
import AdminProductsRoutes from '../../products/routes/admin-products.route';
import AdminBasketsRoutes from '../../baskets/routes/admin-baskets.route';
import AdminCategoriesRoutes from '../../categories/routes/admin-categories.route';
import AdminSubcategoriesRoutes from '../../subcategories/routes/admin-subcategories.route';
import AdminTaxesRoutes from '../../taxes/routes/admin-taxes.route';
import AdminWeightUnitiesRoutes from '../../weight-unities/routes/admin-weight-unities.route';
import AdminTagsRoutes from '../../tags/routes/admin-tags.route';

export default function AdminRootRoutes() {
  return (
    <Route path={BASE_ADMIN_V2_PATH}>
      <AuthenticatedAdminGuard>
        <AdminLayout>
          {/* Clients */}
          <AdminUsersRoutes />
          <AdminDeliveryPointsRoutes />
          <AdminOrganizationsRoutes />
          <AdminSegmentsRoutes />

          {/* Catalog */}
          <AdminProductsRoutes />
          <AdminBasketsRoutes />
          <AdminCategoriesRoutes />
          <AdminSubcategoriesRoutes />
          <AdminTaxesRoutes />

          {/* Sales */}
          <AdminOrdersRoutes />
          <AdminInvitationsRoutes />

          {/* Delivery */}
          <AdminDeliveryCitiesRoutes />
          <AdminDeliveryZonesRoutes />

          {/* Settings */}
          <AdminWeightUnitiesRoutes />
          <AdminTagsRoutes />

          {/* Statistics */}
          <AdminStatisticsRoutes />

          {/* NEED TO BE MOVED */}
          <Route exact path={ADMIN_STATISTICS_V2_APP_PATHS.COMMISSIONS} component={AdminStatisticsCommissionPage} />
          <Route exact path={ADMIN_STATISTICS_V2_APP_PATHS.SALES} component={AdminStatisticsSalesPage} />
        </AdminLayout>
      </AuthenticatedAdminGuard>
    </Route>
  );
}
